export default "data\n"